import { css } from 'styled-components';
import zIndexCss from './zIndex.css';

// Define the z-index of all our components in one place so we can easily see
// their relationship and avoid bugs arising from arbitrary z-index values.
export const zIndexTokens = css`
  ${zIndexCss}
`;
